export default __webpack_public_path__ + "static/media/groupIconLight.1d9616d7.svg";